import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { AssessmentForm } from "../components/AssessmentForm";
import { LoadingState } from "../components/LoadingState";
import { ACCESS_PASS_STORAGE_KEY, api } from "../lib/api";
import { DISCLAIMER } from "../lib/constants";
import type { AssessmentInput } from "../lib/types";

export function AssessmentPage() {
  const navigate = useNavigate();
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");
  const handleSubmit = async (input: AssessmentInput) => {
    setSubmitting(true); setError("");
    try {
      const accessPassToken = localStorage.getItem(ACCESS_PASS_STORAGE_KEY) ?? undefined;
      const result = await api.createAssessment({ ...input, accessPassToken });
      sessionStorage.setItem(`preview:${result.reportId}`, JSON.stringify(result.preview));
      if (result.accessPass) sessionStorage.setItem(`pass-status:${result.reportId}`, JSON.stringify(result.accessPass));
      navigate(`/preview/${result.reportId}`);
    } catch (caught) {
      setError(caught instanceof Error ? caught.message : "We could not create your report.");
      setSubmitting(false);
    }
  };
  if (submitting) return <main className="shell px-5 py-10"><LoadingState /></main>;
  return (
    <main className="px-5 py-12 md:px-10 md:py-20">
      <div className="shell max-w-5xl">
        <div className="mb-10 max-w-2xl"><p className="eyebrow">Your assessment</p><h1 className="font-display text-5xl leading-none md:text-7xl">Share the details. We’ll find the pattern.</h1><p className="mt-5 text-ink/60">There are no perfect answers. Specific, accurate detail makes the report more useful.</p></div>
        {error && <p className="mb-5 rounded-2xl bg-coral/15 p-4 text-sm font-semibold">{error}</p>}
        <AssessmentForm onSubmit={handleSubmit} submitting={submitting} />
        <p className="mx-auto mt-7 max-w-3xl text-center text-xs leading-5 text-ink/45">{DISCLAIMER}</p>
      </div>
    </main>
  );
}
